// Import dependencies
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import queryString from 'query-string';
import io from 'socket.io-client';
import axios from 'axios';
import cookie from 'js-cookie';
import { FaArrowLeft } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';

// Import components
import LogoutButton from '../../../../components/reusables/logout';

// Import styling
import './LiveStreamPage.css';

//Import helpers
import { tokenize } from '../../../../helper';

// Import config
import config from '../../../../configs/config.json';
const API_URL = config.API_URL;
const WS_URL = config.WS_URL;
const VIDEO_API_URL = API_URL + '/video';
const ADMIN_API_URL = API_URL + '/admin';
const SETTINGS_URL = ADMIN_API_URL + '/settings';

class LiveStreamPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            memberID: 0,
            browserLoaded: new Date(),
            vimeoID: '',
            liveStreamOnline: false,
            offlineMessage: '',
            redirectToggle: false,
            redirectLink: '',
            redirectMessage: '',
        }

        this.socket = null;
    }

    showModal = (type) => {
        var state = this.state;
        state[type] = true;

        this.setState(state);
    }

    hideAllModals = () => {
        this.setState({
            redirectToggle: false,
        })
    }

    handleModalClose = () => {
        this.hideAllModals();
    }


    componentDidMount = () => {

        // Verify the token from the cookie (if exists)
        var token = cookie.get('token');
        var user_type = cookie.get('user-name');
        console.log(user_type)
        if (token) {
            // Success, 
        } else {
            // Faiure, send them back to the welcome page
            window.location.href = '/';
        }

        console.log(this.props.location)
        var { id } = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });

        this.setState({ memberID: id })

        this.pollServerSettings();

        // Poll server every 30 seconds
        // this.interval = setInterval(this.pollServerSettings, 10000);

        this.socket = io(`${WS_URL}`);

        this.socket.on('connect', client => {
            console.log("Connected to websocket server... Ready for further commands...")
        });

        this.socket.on('command', command => {
            this.processCommand(command)
        })

        this.socket.on('offline_message', message => {
            console.log("NEW OFFLINE MESSAGE RECEIVED FROM SOCKET");
            this.setState({ offlineMessage: message });
        })

    }

    processCommand = (command) => {
        console.log('Command received: ', command);

        switch (command) {
            case 'refresh':
                window.location.reload(true);
                break;
            case 'online':
                this.setState({ liveStreamOnline: true });
                break;
            case 'offline':
                this.setState({ liveStreamOnline: false });
                break;
            default:
                console.log("Unable to process command");
                break;
        }
    }

    createLivestreamView = () => {
        console.log(cookie)
        axios.post(`${SETTINGS_URL}/analytics/livestream-view`, tokenize())
            .then(response => {
                if (response.data.success) {
                    console.log(response.data)
                } else {
                    console.log("error")
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    pollServerSettings = () => {

        // Poll back-end to check if browser needs to be refreshed
        axios.get(`${VIDEO_API_URL}/livestream/settings`, tokenize())
            .then(response => {

                if (response.data.success) {

                    console.log(response.data.settings)
                    var serverSettings = response.data.settings;

                    var refreshIssued = new Date(serverSettings.BROWSER_REFRESH.issued);

                    // Check if the refresh command is newer than the time the page was loaded by browser
                    if (refreshIssued > this.state.browserLoaded) {
                        // Refresh the browser
                        console.log("Refreshing browser");
                        window.location.reload();
                    }

                    if (serverSettings.EVENT_ID.value !== this.state.vimeoID) {
                        this.setState({ vimeoID: serverSettings.EVENT_ID.value });
                        console.log("Setting event ID: ", this.state.vimeoID)
                    }

                    if (serverSettings.OFFLINE_MESSAGE.value !== this.state.offlineMessage) {
                        this.setState({ offlineMessage: serverSettings.OFFLINE_MESSAGE.value });
                    }

                    var redirectValue = serverSettings.ZOOM_REDIRECT.value === "0" ? false : true
                    console.log(redirectValue)
                    var zoomLink = serverSettings.ZOOM_LINK.value;
                    this.setState({ redirectToggle: redirectValue, redirectLink: zoomLink }, () => {
                        console.log("JUST SET STATE LOL")
                    })




                    if (serverSettings.ZOOM_MESSAGE.value !== this.state.redirectMessage) {
                        this.setState({ redirectMessage: serverSettings.ZOOM_MESSAGE.value });
                    }


                    if (serverSettings.IS_LIVE.value !== this.state.liveStreamOnline) {
                        this.setState({ liveStreamOnline: serverSettings.IS_LIVE.value });
                        // Set the volume to 70%
                        var livestreamFrame = document.getElementById('livestreamFrame');
                        livestreamFrame.volume = 0.7;
                    }

                } else {
                    // Failed to get livestream meta
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    openZoomLink = () => {
        // Save user access in backend
        this.createLivestreamView()
        // Open the Zoom link and insert user's name
        var userName = cookie.get('user-name'); // Load name from cookie
        var urlSafeName = encodeURI(userName); // Encode name to URL safe
        var zoomLink = this.state.redirectLink;
        var url = `${zoomLink}&uname=${urlSafeName}`;
        console.log("OPEN ZOOM", url);
        window.open(url, '_blank');
    }

    render() {
        var parsedHTMLMessage = ReactHtmlParser(this.state.offlineMessage);
        var parsedRedirectMessage = ReactHtmlParser(this.state.redirectMessage);

        return (
            <div id='liveStreamContainer'>
                <nav id='videoNavbar' className="navbar navbar-light bg-light justify-content-between">
                    <div>
                        <button className='btn btn-secondary btn-sm' onClick={() => window.location.href = '/videos'}><FaArrowLeft size='1em' /> Back to Video Library</button>
                    </div>

                    <div>
                        <LogoutButton size='small' />
                    </div>
                </nav>

                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.redirectToggle}
                    onHide={this.handleModalClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Zoom Redirection
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body centered>
                        {parsedRedirectMessage}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='danger' onClick={this.handleModalClose}>Cancel</Button>
                        <Button variant='success' onClick={this.openZoomLink}>Click to join meeting</Button>
                    </Modal.Footer>
                </Modal>

                {
                    /* If the live stream is online display the Vimeo frame and chat frame. */
                    // eslint-disable-next-line
                    (this.state.liveStreamOnline == true) ?


                        <div id='innerLiveStreamContainer'>

                            <iframe title='Livestream' id='livestreamFrame' src={`https://vimeo.com/event/${this.state.vimeoID}/embed`} width="640" height="360" frameBorder="0" allow="autoplay; fullscreen" allowFullScreen />

                            <iframe title='Chat' id='chatFrame' src={`https://vimeo.com/event/${this.state.vimeoID}/chat`} width="250" height="400" frameBorder="0" />
                        </div>

                        :
                        //  Livve stream is offline display offline message
                        <div id='offlineMessageContainer'>
                            <div>
                                <div class='container-fluid' id='monitor-display'><div class='row align-items-center'><div class='col'><div class='row monitor-frame'><div class='col col-sm-12'><div class='mobile-camera d-md-none'></div></div><div class='col text-center monitor-screen' id='h1-fix'><div class='icon-graduation'></div>
                                    <h3>Upcoming Live Courses</h3>
                                    <div class='course-list'>
                                        {parsedHTMLMessage}
                                    </div>
                                    <h1>OLLI Remote Learning Center</h1>
                                </div><div class='col col-sm-12 text-center'><div class='mobile-button d-md-none'></div></div></div><div class='row justify-content-center monitor-post'><div class='col d-none d-md-block col-2'></div></div><div class='row justify-content-center monitor-stand'><div class='col d-none d-md-block col-10 col-md-8'></div></div></div></div></div>
                            </div>
                        </div>
                }
            </div>
        )
    }
}

export default LiveStreamPage;